/*
 * Yafeapedia
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.1
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.64
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import AuthorDTO from './AuthorDTO';

/**
 * The UserDTO model module.
 * @module model/UserDTO
 * @version 1.0.1
 */
export default class UserDTO {
  /**
   * Constructs a new <code>UserDTO</code>.
   * @alias module:model/UserDTO
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>UserDTO</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/UserDTO} obj Optional instance to populate.
   * @return {module:model/UserDTO} The populated <code>UserDTO</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new UserDTO();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'Number');
      if (data.hasOwnProperty('username'))
        obj.username = ApiClient.convertToType(data['username'], 'String');
      if (data.hasOwnProperty('privileges'))
        obj.privileges = ApiClient.convertToType(data['privileges'], 'String');
      if (data.hasOwnProperty('enabled'))
        obj.enabled = ApiClient.convertToType(data['enabled'], 'Boolean');
      if (data.hasOwnProperty('author'))
        obj.author = AuthorDTO.constructFromObject(data['author']);
    }
    return obj;
  }
}

/**
 * @member {Number} id
 */
UserDTO.prototype.id = undefined;

/**
 * @member {String} username
 */
UserDTO.prototype.username = undefined;

/**
 * @member {String} privileges
 */
UserDTO.prototype.privileges = undefined;

/**
 * @member {Boolean} enabled
 */
UserDTO.prototype.enabled = undefined;

/**
 * @member {module:model/AuthorDTO} author
 */
UserDTO.prototype.author = undefined;

